import PropTypes from "prop-types";

export const RegionDataResource = {
    country: PropTypes.shape({ name: PropTypes.string.isRequired, showRoute: PropTypes.string.isRequired }),
    state: PropTypes.shape({ name: PropTypes.string.isRequired, showRoute: PropTypes.string.isRequired }),
    county: PropTypes.shape({ name: PropTypes.string.isRequired, showRoute: PropTypes.string.isRequired, type: PropTypes.string.isRequired}),
    subcounty: PropTypes.shape({ name: PropTypes.string.isRequired, showRoute: PropTypes.string.isRequired, type: PropTypes.string.isRequired}),
    category: PropTypes.shape({ name: PropTypes.string.isRequired, showRoute: PropTypes.string.isRequired }),
};
